import { useState, useEffect } from 'react';
import { Box, Flex, useToast } from "@chakra-ui/react";

import { MdDashboardCustomize } from 'react-icons/md';
import WarningTextMessage from '../../../global/components/helper-components/components/WarningTextMessage';
import appConfig from '../../../../config/app-config';
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton';
import ReactIconDisplay from '../../../global/components/helper-components/components/ReactIconDisplay';
import { FaFileCircleCheck } from 'react-icons/fa6';
import LaunchdeckCloseButton from '../../../global/components/helper-components/components/LaunchdeckCloseButton';
import DsrGenericLoadingModal from '../../../digital-sales-room/components/DsrGenericLoadingModal';
import { triggerLaunchdeckToast } from '../../../global/helpers/global-helpers';
import { IoIosArrowDroprightCircle } from 'react-icons/io';
import useLaunchdeckModal from '../../../global/hooks/use-launchdeck-modal';
import LaunchdeckFormInput from '../../../forms/TextInputField/components/LaunchdeckFormInput';
import LaunchdeckFormTextAreaInput from '../../../forms/TextInputField/components/LaunchdeckFormTextAreaInput';



export function CreateRoomWithAiForm({
  showLoader,
  isMobileView,
  handleIsUploadingState,
  handleClickModalCloseButton,
  handleWaitTillRedirect,
  uploadFiles,
  uploadFileMultithreaded,
  uploadFilesReset,
  createGenAiRoom,
  setNotifyGenAiRoomReady,
  // Redux state
  uploadFilesState
}) {

  const instructionsCharacterLimit = 300;
  const toast = useToast();
  const [showIsGeneratingRoom, setShowIsGeneratingRoom] = useState(false)
  const { openLaunchdeckModal, closeLaunchdeckModal } = useLaunchdeckModal();

  const {
    maxVideoFileSize,
    minVideoFileSizeForMultithreadedUpload,
    displayMaxFileSize,
  } = appConfig;


  const [isLoading, setIsLoading] = useState("")
  const [instructions, setInstructions] = useState("")
  const [isEmptyInstructions, setIsEmptyInstructions] = useState("")
  const [isEmptyDsrTitle, setIsEmptyDsrTitle] = useState(false)
  const [isEmptyFileError, setIsEmptyFileError] = useState(null)

  const [errorMessage, setErrorMessage] = useState("")
  const [dsrTitleDisplay, setDsrTitleDisplay] = useState("")
  const [selectedFile, setSelectedFile] = useState("")
  const [uploadResults, setUploadResults] = useState("")
  const [uploadedFileSpecs, setUploadedFileSpecs] = useState(null)
 

  const [notifyLater, setNotifyLater]= useState(false)


  const handleSwitchToUserCreation = () => {
    openLaunchdeckModal('create-new-room-form')
  }

  const setShowNextLoadingState = () => {
    setShowIsGeneratingRoom(true)
  }

  const handleNotifyLater = () => {
    setNotifyLater(true)
    setNotifyGenAiRoomReady(true)
    closeLaunchdeckModal()
  }

  useEffect(() => {
    if (notifyLater === true) {
      toast(
        triggerLaunchdeckToast({
          useCase: "show-success-state",
          label: "We'll let you know in a few minutes when the Room's ready",
          isMobileView
        })
      )
      handleClickModalCloseButton()
    }
  }, [notifyLater])

  useEffect(() => {
    if (uploadFilesState) {
      const { isLoading: isUploading, results: uploadResults, error: uploadingError } = uploadFilesState;
   
      if (typeof isUploading === "boolean") {
        setIsLoading(isUploading)
      }

      if (uploadingError) {
        setErrorMessage(uploadingError)
      }

      if (uploadResults) {
        setUploadResults(uploadResults)
        uploadResults?.files && setShowNextLoadingState()
      }
    }
  }, [uploadFilesState])

  useEffect(() => {
    // Send the data of the uploaded file to generate room
    if (!isLoading &&
      !errorMessage &&
      Array.isArray(uploadResults?.files)) {

      setUploadedFileSpecs(uploadResults.files[0])
      uploadFilesReset();

    }
  }, [uploadResults])

  useEffect(() => {
    if (uploadedFileSpecs && instructions) {
      createGenAiRoom({
        dsrTitle: dsrTitleDisplay,
        instructions: instructions,
        referenceFile: uploadedFileSpecs
      })
      setUploadedFileSpecs(null)
    }
  }, [uploadedFileSpecs, instructions])

  const handleFileInputChange = (e) => {
    const file = e?.target?.files[0];
    setIsEmptyFileError(false)

    const validateInput = (file) => {
      if (!file) {
        throw new Error("Uploaded file must be object");
      }

      if (!file?.name) {
        throw new Error("Uploaded file does not have filename");
      }

      if (file?.size > maxVideoFileSize) {
        // File size exceeds the limit
        setErrorMessage(
          `We support the display of files that are ${displayMaxFileSize / (1024 * 1024)} MB or below.`,
        );
        throw new Error("File size exceeds the limit");
      }
    };

    try {
      validateInput(file);
    } catch (e) {
      if (process.env.NODE_ENV === "development") console.log(e);

      return;
    }
    setSelectedFile(file);
  };

  const onChangeHandler = (event) => {
    switch (event.target.name) {
      case ('instructions'): {
        setInstructions(event.target.value)
        isEmptyInstructions && setIsEmptyInstructions(false)
        break;
      }
      case ('dsrTitle'): {
        setDsrTitleDisplay(event.target.value)
        isEmptyDsrTitle && setIsEmptyDsrTitle(false)
        break;
      }
      default: {
        break;
      }
    }
  }

  const handleButtonClick = () => {
    if (!instructions.trim()) {
      setIsEmptyInstructions(true)
    } else {
      setIsEmptyInstructions(false)
    }
    
    if (dsrTitleDisplay?.trim().length < 1) {
      setIsEmptyDsrTitle(true)
    } else {
      setIsEmptyDsrTitle(false)
    }

    if (!selectedFile) {
      setIsEmptyFileError(true)
    }

    if (dsrTitleDisplay.trim() && instructions.trim()) {
      if (!!selectedFile) {
        selectedFile?.size <= minVideoFileSizeForMultithreadedUpload
          ? uploadFiles({ files: [selectedFile], containsImages: false })
          : uploadFileMultithreaded({ file: selectedFile, containsImages: false });

          handleWaitTillRedirect()

          handleIsUploadingState()
      } 
    }
  }

  if (showLoader) {
    return (
    <DsrGenericLoadingModal
      triggerStateChange={showIsGeneratingRoom}
      modalText={showIsGeneratingRoom ? `Got it & generating your Room now...\n It'll be ready in a minute or two.` : `Give us a moment... \nWe're working on understanding the information provided`} 
      handleOkOption = {() => showIsGeneratingRoom && handleNotifyLater()}
      />

)
  } else {

    return (
      <Box m='1.5em' w="100%" >

        <Flex mb='2em' bgGradient="linear(to-r, #2D3748, #243b55)" rounded='0.25em' p='0.5em'>
          <Flex gap={4} p='0.1em' w='100%' justify='space-between' align='center' cursor='pointer' onClick={() => handleSwitchToUserCreation()}>
            <Flex gap={4}>
              <ReactIconDisplay reactIcon={MdDashboardCustomize} color='white' fontSize='1em' mr='0em' />
              <Box fontSize='0.75em' color='white'>
                Have a solid vision for your Room & prefer to tailor it personally?
              </Box>
            </Flex>
            <ReactIconDisplay reactIcon={IoIosArrowDroprightCircle} color='white' fontSize='1em' mr='0em' />
          </Flex>
        </Flex>

        <Box my='1em'>
          <LaunchdeckFormInput
            label='Room name'
            name={'dsrTitle'}
            onChange={onChangeHandler}
            value={dsrTitleDisplay}
            isRequired={true}

            errorLogic={isEmptyDsrTitle}
            errorMessage={'Give your Room a good name'}
          />
        </Box>

        <Box mt='1em' mb='2em' data-driver="step-6">
          <LaunchdeckFormTextAreaInput
           label="What topics should the Room highlight?"
           name="instructions"
           onChange={onChangeHandler} 
           value={instructions}        
           isRequired={true}

           fontSize='0.875em'
           errorLogic={isEmptyInstructions}
           errorMessage={'Instruct which content should be emphasized & presented \nE.g. Showcase my new concierge service for corporate customers'}
           charLimit={instructionsCharacterLimit}
           />
        </Box>

       
        <Flex my='1em' position='relative' minH='6em' w='100%' border={(selectedFile || isEmptyFileError) ? "1px solid" :'1px dashed'} borderColor={selectedFile ? "brandDark.500" : isEmptyFileError ? 'brandPink.500' : 'gray.300'} rounded='0.25em' p='1.25em 1em'
        transition='all 0.3s ease-in-out'
        >
        <Box fontSize="0.75em" fontWeight='600' position='absolute' bg='white' px='0.5em' top='-10px' left='0.5em' textAlign='left' mb='0.5em'>Reference Document</Box>
   
          {selectedFile ?
            <Flex w='100%' p='0em 0.5em'  justify='space-between' align='center'>

              <Flex justify='flex-start' align='center' gap={4} flex='auto'>
                <Box as={FaFileCircleCheck} boxSize="1.5em" />
                <Box>
                  <Box color='brandDark.500' fontSize='0.75em' fontStyle='italic' className='truncate-long-text'>
                    {selectedFile?.name ? selectedFile?.name : "File"}
                  </Box>
                  <Box color='gray.500' fontSize='0.7em'>
                    PDF
                  </Box>
                </Box>


              </Flex>
              <Box w='1.5em'>
                <LaunchdeckCloseButton handleCloseModal={() => setSelectedFile(null)} />
              </Box>

            </Flex> :
            <Flex w='100%' justify='center' direction='column' align='center' gap='2em'>

              <Flex align='center' direction='column'>
              <label>
                <input
                  style={{ display: "none" }}
                  type="file"
                  accept=".pdf, .ppt, .pptx"
                  onChange={handleFileInputChange}
                />
                <LaunchdeckButton
                  bg="brandDark.500"
                  color="white"
                  px="2em"
                  label="Select"
                />
              </label>
              <Box fontSize='0.7em' color='gray.500' mt='0.5em'>PDF formats only</Box>
              </Flex>
            </Flex>
          }
        </Flex>
        <Box mt='-0.5em'>
          <WarningTextMessage errorLogic={isEmptyFileError} message=' Provide a PDF document as a reference to generate relevant content' />
          </Box>
     

  

        <Box my='2em'/>

        <Flex direction='column' mt='1em' justify='center' alignItems='center'>
          <Flex justify={['center', 'flex-end', 'flex-end', 'flex-end']} w='100%'>
            <LaunchdeckButton bg='brand.500' color='white' onClick={() => handleButtonClick()} label='Create draft' />
          </Flex>
        </Flex>
      </Box>
    )
  }
}
